export const removeQueryString = (url) => {
	return url && url.indexOf('?') > -1 ? url.substr(0, url.indexOf('?')) : url;
};
